import { Component, OnInit, OnDestroy, ViewChild, ElementRef, OnChanges, AfterViewInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { MessageService } from 'primeng/api';
//import { Logger } from '../../../core/logger/logger.service';


import { Location } from '@angular/common';

import { Subscription } from 'rxjs';
import { Staff } from 'src/app/entity/Staff';
import { ProspectService } from 'src/app/service/prospect.service';
import { FactureService } from 'src/app/service/facture.service';
import { StandService } from 'src/app/service/stand.service';
import { Prospect } from 'src/app/entity/Prospect';
import { Contact } from 'src/app/entity/Contact';
import { Client } from 'src/app/entity/exhibitor';
import { Stand } from 'src/app/entity/Stand';
import { ExhibitorService } from 'src/app/service/exhibitor.service';
import { ContactService } from 'src/app/service/contact.service';

import { PanierFormComponent } from '../../forms/panier-form/panier-form.component';
import { MailsService } from 'src/app/service/mails.service';
import { Facture } from 'src/app/entity/Facture';
import { ComposeMailComponent } from '../../email/include/compose-mail/compose-mail.component';
import { MatStepper } from '@angular/material/stepper';
import { ContactFormComponent } from '../../forms/contact-form/contact-form.component';
import { FacturationFormComponent } from '../../forms/facturation-form/facturation-form.component';


@Component({
    selector: 'app-new-exhibitor'
    , templateUrl: './new-exhibitor.component.html',
    styleUrls: ['./new-exhibitor.component.scss']
})

export class NewExhibitorComponent implements OnInit, OnDestroy, AfterViewInit {
    standsStepTitle: string = "Stands";
    isSignature: boolean = false;



    ngAfterViewInit(): void {
        this.image();
    }
    @ViewChild(PanierFormComponent)
    private panierFormComponent: PanierFormComponent;

    @ViewChild(FacturationFormComponent)
    private facturationFormComponent: FacturationFormComponent;


    showListStands: boolean;
    user: Staff;
    idDetail: number;
    isDetail: boolean;
    isLienar: boolean;
    @ViewChild('stepper') stepper: MatStepper;
    done: boolean;
    clientType: string;


    @ViewChild(ComposeMailComponent)
    private composeMailComponent: ComposeMailComponent;

    initListPanier() {
        console.log("initListPanier");

        this.panierFormComponent.getFacture();
    }


    contactsChanged() {
        console.log('new exhibit contactsChanged');

        this.facturationFormComponent.findContacts()
    }

    getClient(idClient: number) {
        this.exhibitorService.getExhibitor(idClient).subscribe(result => {
            this.selectedClient = result;
            this.typeClient()

            this.projectId = this.selectedClient.projetId.projetId;
            this.selectedProspect = this.selectedClient.prospectId;
            this.isEnglish = this.selectedProspect.langue == "en"
            this.title = this.selectedProspect.raisonSocial;

            if (this.selectedClient && this.selectedClient.contact)
                this.createContractIfNotExiste();

            this.user = this.selectedClient.prospectId.utilisateurs;
            this.buildPersonalForm();
        })


        this.exhibitorService.findStandsClient(this.idClient).subscribe(result => {
            this.stands = result;
        })
    }

    subscriptionContact: Subscription;

    subscriptionStands: Subscription;
    title = 'Create Exhibitor';
    personalForm: FormGroup;
    facturationForm: FormGroup;
    idUser: number;
    contactForm: FormGroup;

    addressForm: FormGroup;
    idProspectERP: number;
    idClient: number;

    projectId: number;
    selectedProspect: Prospect;
    selectedContact: Contact;
    selectedClient: Client;
    stands: Stand[];
    constructor(
        private formBuilder: FormBuilder,
        private router: Router,
        private messageService: MessageService,
        private activatedRoute: ActivatedRoute,
        private prospectService: ProspectService,
        private exhibitorService: ExhibitorService,
        private mailsService: MailsService,
        private contactService: ContactService,
        private factureService: FactureService,
        private location: Location,
        private standService: StandService) {
        this.idUser = +    localStorage.getItem('idUser');

        //   this.idProspectCRM = +this.route.snapshot.queryParamMap.get("idProspect")
        this.activatedRoute.params.subscribe(params => {


            this.idClient = + params['idClient'];


            this.idDetail = +params['idDetail'];
            if (params['idDetail'])
                this.isDetail = true;
            this.getClient(this.idClient);
        })

        this.stands = [];

        this.subscriptionStands = this.exhibitorService.getSelectedStand().subscribe(stands => {
            if (stands) {
                this.stands = stands;
            }
        });
        this.subscriptionContact = this.contactService.getSelectedContact().subscribe(contact => {
            if (contact) {
                this.selectedContact = contact;
            }
        });

    }

    ngOnInit() {
        // this.buildPersonalForm();

        this.buildContactForm();
        this.buildAddressForm();
        this.buildFacturationForm();
        this.image()

        //  this.getProspectCrm(this.idProspectCRM);
    }
    buildFacturationForm() {
        this.facturationForm = this.formBuilder.group({
            'billingCompany': [''],
            'contactSelect': [''],
            'tel': [''],
            'mail': [''],
            'company': [''],
            'currency': [''],
            'tva': '',
            'timbre': '',
            'finance': '',
            'annuler': '',
            'observation': '',
            'montanttva': '',
            'dateInvoice': ''

        });
    }

    retour() {

        window.history.back();
        // this.router.navigateByUrl('/client-list/'+this.idUser*9555+'/'+this.idClient)
    }

    /* buildFinanceForm() {
      f   this.facturationForm = this.formBuilder.group({
             'sociFact': [this.selectedProspect.raisonSocial],
             'devise': [this.selectedProspect.nrc],
             'tva': [this.selectedProspect.nif],
             'valeurTva': [this.selectedProspect.nai]
         });
     }
 */




    buildPersonalForm(): void {

        this.personalForm = this.formBuilder.group({
            'raisonSocial': [this.selectedProspect.raisonSocial],
            'signalitique': [this.selectedProspect.signalitique],

            'nrc': [this.selectedProspect.nrc],
            'nif': [this.selectedProspect.nif],
            'nai': [this.selectedProspect.nai],
            'vatNumber': [this.selectedProspect.vatNumber],

            'rcNumber': [this.selectedProspect.rcNumber],
            "pays": [this.selectedProspect.pays],
            //  'secteurActivite': [this.selectedProspect.secteur],
            // 'paysActivite': [this.selectedProspect.paysId],
            'adresse': [this.selectedProspect.adresse],
            'langue': [this.selectedProspect.langue],
            'sociFact': [this.selectedProspect.sociFact],
            'ordre': [this.selectedProspect.ordre],
            'pavillon': [this.selectedProspect.pavillon],


            'devise': [this.selectedProspect.devise],

            'statusjudiciaire': [this.selectedProspect.statusjudiciaire],
            'origineContact': [this.selectedProspect.origineContact],
            'historique': [this.selectedProspect.historique],

        });
        //console.log('this.selectedProspect.langue' + this.selectedProspect.langue);

    }

    buildContactForm(): void {
        this.contactForm = this.formBuilder.group({
            'nom': [''],
            'mobile': [''],
            'tel': [''],
            'mail': [''],
            'titres': [''],
            'typeContact': ['']


        });
    }

    buildAddressForm(): void {
        this.addressForm = this.formBuilder.group({
            'street': [''],
            'city': [''],
            'state': [''],
            'zip': [''],
        });
    }

    saveProspect() {


        //  this.selectedProspect.secteurId = this.personalForm.value.secteurActivite;

        /*    if (this.selectedProspect.secteurId && !this.selectedProspect.secteurId.secteurId) {
                this.prospectService.createSecteurIfNotExiste(this.personalForm.value.secteurActivite).subscribe(result => {
                    this.selectedProspect.secteurId = result;
                    const editedProspect = this.getProspect();
                    this.saveProspectDirect(editedProspect);
                });
            }
            else {*/
        //const editedProspect = this.getProspect();
        //this.saveProspectDirect(editedProspect);
        // }







    }

    update() {
        this.exhibitorService.updateChamp(this.selectedClient, "finance", this.selectedClient.finance).subscribe(
            result => {
                let st = "Payé"
                if (!this.selectedClient.finance)
                    st = 'Non payé'
                this.messageService.add({ severity: 'success', summary: st, detail: 'Etat modifié' });
            }
        )
    }

    saveProspectDirect(editedProspect: Prospect) {
        this.prospectService.saveProspectErp(editedProspect).subscribe(result => {
            this.selectedProspect = result;
            this.title = this.selectedProspect.raisonSocial;

            this.isEnglish = this.selectedProspect.langue == "en"

        })
    }


    saveContact() {
        /*    if (this.selectedContact && this.selectedContact.mail)
                this.selectedContact.mail = this.selectedContact.mail.trim()
            this.exhibitorService.affectContactExhibitor(this.selectedClient.idClient, this.selectedContact.contactId).subscribe(result => {
    
                this.createContractIfNotExiste();
    
            })*/
    }

    createContractIfNotExiste() {

        this.factureService.createContractIfNotExiste(this.selectedClient.idClient).subscribe(result => {


            if (result)
                this.factureService.nextInvoice(result);


        });
    }
    saveListPanier() {
        this.panierFormComponent.saveList();
    }


    /**
     * Return true if at least either personForm, workForm or addressForm is invalid
     */
    invalidForms(): boolean {
        return (this.personalForm.invalid ||
            this.contactForm.invalid ||
            this.addressForm.invalid);
    }


    getProspect(): Prospect {

        this.selectedProspect.raisonSocial = this.personalForm.value.raisonSocial;
        this.selectedProspect.signalitique = this.personalForm.value.signalitique;



        this.selectedProspect.nrc = this.personalForm.value.nrc;
        this.selectedProspect.nif = this.personalForm.value.nif;
        this.selectedProspect.nai = this.personalForm.value.nai;
        this.selectedProspect.adresse = this.personalForm.value.adresse;
        this.selectedProspect.pays = this.personalForm.value.pays;
        this.selectedProspect.vatNumber = this.personalForm.value.vatNumber;

        //   this.selectedProspect.paysId = this.personalForm.value.paysActivite;

        this.selectedProspect.langue = this.personalForm.value.langue;

        this.selectedProspect.sociFact = this.personalForm.value.sociFact;
        this.selectedProspect.devise = this.personalForm.value.devise;
        this.selectedProspect.statusjudiciaire = this.personalForm.value.statusjudiciaire;
        this.selectedProspect.origineContact = this.personalForm.value.origineContact;
        this.selectedProspect.historique = this.personalForm.value.historique;


        return this.selectedProspect;
    }
    ngOnDestroy(): void {
        this.subscriptionContact.unsubscribe()
        this.subscriptionStands.unsubscribe();
    }


    imprimerDossier() {
        this.printFiche();
        this.printInvoice(1, false,false);
    }


    isEnglish: boolean;
    isLoadingFacture: boolean
    printInvoice(tentative: number, isEnglish,isWord) {
        this.isLoadingFacture = true;
        //console.log("isEnglish",isEnglish);

        this.exhibitorService.findContratClient(this.idClient).subscribe(result => {
      //    this.factureService.printPersonaliserDocx(result, isEnglish, this.isSignature ).subscribe(

           this.factureService.printPersonaliser(result, isEnglish, this.isSignature, '', '', '',isWord).subscribe(
                (res: any) => {
                    if (!res && tentative < 4)
                        this.printInvoice(tentative + 1, isEnglish,isWord)
                    else {

                        try {
                            var filename = 'restfile.pdf';

                            filename = filename.replace(/[/\\?%*:|"<>]/g, '-');

                            //   console.log("dddqq",res);
                            var FileSaver = require('file-saver');
                          //  if(isWord)
                         //   FileSaver.saveAs(res, "facture.doc");
                   //   else{
   var fileURL = URL.createObjectURL(res);
                           window.open(fileURL);
                       //     } 
                         
                            this.isLoadingFacture = false;
                        } catch (error) {
                            this.isLoadingFacture = false;
                        }






                    }



                });
        })

    }



    printFiche() {

        this.exhibitorService.printFiche(this.idClient).subscribe(
            (res: any) => {

                var filename = 'restfile.pdf';

                filename = filename.replace(/[/\\?%*:|"<>]/g, '-');



                var fileURL = URL.createObjectURL(res);
                window.open(fileURL);

            }
        );
    }

    typeClient() {

        if (this.selectedClient.type === 'E')
            this.clientType = "Exposant";
        else if (this.selectedClient.type === 'ES')
            this.clientType = "Exposant Sponsor";
        else if (this.selectedClient.type === 'C')
            this.clientType = "Co-Exposant";
        else if (this.selectedClient.type === 'D')
            this.clientType = "Délégué";
        if (this.selectedClient.type === 'S')
            this.clientType = "Sponsor";
        if (this.selectedClient.type === 'P') {
            this.clientType = "Constructeur";
            this.standsStepTitle = "Clients";
        }

        //console.log(this.clientType);

    }


    image() {
        setTimeout(() => {
            if (document.getElementById("cdk-step-label-0-0")) {
                document.getElementById("cdk-step-label-0-0").innerHTML = ' <img src="../../assets/img/morceau/1.png" height="35">Entreprise';
                document.getElementById("cdk-step-label-0-1").innerHTML = ' <img src="../../assets/img/morceau/2.png" height="35">Contact';
                document.getElementById("cdk-step-label-0-2").innerHTML = ' <img src="../../assets/img/morceau/3.png" height="35">' + this.standsStepTitle;
                document.getElementById("cdk-step-label-0-3").innerHTML = ' <img src="../../assets/img/morceau/4.png" height="35">Finance';
                document.getElementById("cdk-step-label-0-4").innerHTML = ' <img src="../../assets/img/morceau/5.png" height="35">Contenu Proforma';
                //   document.getElementById("cdk-step-label-0-5").innerHTML = ' <img src="../../assets/img/morceau/6.png" height="35">Panier';

                document.getElementById("cdk-step-label-0-5").innerHTML = ' <img src="../../assets/img/morceau/5.png" height="35">Délégué';
                document.getElementById("cdk-step-label-0-6").innerHTML = ' <img src="../../assets/img/morceau/6.png" height="35">Attachements';





            }
            else {
                this.image()
            }
        }, 100);



    }

    selectionChange($event) {

        let str = this.router.url.split("/")
        str[str.length - 1] = $event.selectedIndex
        this.location.replaceState(str.join('/'))

    }
}
 